import React from "react";

import "./Login.css";

import { Alert, Card, Form, Input, Button } from "antd";
import { useTranslation } from "react-i18next";
import useBreakpoint from "../../utils/hooks/useBreakpoint";

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 12 },
};
const tailLayout = {
  wrapperCol: { offset: 8, span: 12 },
};

export default function Login({ login }) {
  const { t } = useTranslation("login");
  const [error, setError] = React.useState(null);
  const { isMobile } = useBreakpoint();

  function onFinish(form) {
    login(form).catch(() => {
      setError(t("failedLogin"));
    });
  }

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const formLayout = isMobile
    ? {
        labelCol: { span: 24 },
        wrapperCol: { span: 24 },
      }
    : layout;

  const formTailLayout = isMobile
    ? {
        wrapperCol: { span: 24 },
      }
    : tailLayout;

  return (
    <Card className="login-card">
      <h1>{t("login")}</h1>
      <Form
        {...formLayout}
        name="basic"
        initialValues={{ remember: true }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Form.Item label={t("username")} name="username">
          <Input />
        </Form.Item>

        <Form.Item label={t("password")} name="password">
          <Input.Password />
        </Form.Item>

        {/* <Form.Item {...formTailLayout} name="remember" valuePropName="checked">
          <Checkbox>Remember me</Checkbox>
        </Form.Item> */}
        <Form.Item {...formTailLayout} hidden={error ? false : true}>
          <Alert message={error} type="error" />
        </Form.Item>

        <Form.Item {...formTailLayout}>
          <Button className="touch-button" type="primary" htmlType="submit">
            {t("login")}
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
}
